import { buildAsturHeaders } from '@/endpoints/channel/asturHeaders';
import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../../requestOptions';

export type GlobalCommonalityDeleteData = Readonly<{
  message: string;
  deleted_id: number;
  // Decorate fan-out runs asynchronously on the SPC worker pool — see postGlobalCommonalityBulk.
  decorate_fanout_enqueued: boolean;
  decorate_affected_subscriptions: number;
}>;

type GlobalCommonalityDeleteResponse = Readonly<{
  data: GlobalCommonalityDeleteData;
}>;

export async function deleteGlobalCommonality(
  scope: RequestScope,
  args: { id: number },
  options: WriteRequestOptions
): Promise<ChannelApiResponse<GlobalCommonalityDeleteData>> {
  try {
    const res = await scopedChannelApi(scope).delete<GlobalCommonalityDeleteResponse>(`atts/commonality/global/${args.id}`, {
      ...options,
      headers: buildAsturHeaders(),
    });

    if (!res.data?.data) {
      throw new Error('Invalid global commonality delete response');
    }

    return {
      data: res.data.data,
      status: res.status,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
